import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ConstantService } from 'src/app/service/constant.service';
import { GamesService } from 'src/app/service/games.service';
import { PagerService } from 'src/app/service/pager.service';
import { MarketService } from 'src/app/service/market.service';
import { CasinoService } from 'src/app/service/casino.service';
import { BalaBalanceModel } from 'src/app/models/common.model';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-market-history',
  templateUrl: './market-history.component.html',
  styleUrls: ['./market-history.component.styl']
})
export class MarketHistoryComponent implements OnInit {

  @ViewChild('slickAModal') slickAModal: SlickCarouselComponent;
  @ViewChild('slickBModal') slickBModal: SlickCarouselComponent;
  @ViewChild('slickCModal') slickCModal: SlickCarouselComponent;
  @ViewChild('slickDModal') slickDModal: SlickCarouselComponent;
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  // IsVerified = false;
  // @Input() Token: any;

  IsCallMade = false;

  Token = '';
  UserName = 'User';
  GameList: any = [];
  TempGameList: any = [];
  SelectedGame: any = 0;
  SelectedGameCode: any = '';
  SelectedGameType: string = "Live";
  StartDate: any;
  EndDate: any;
  MaxDate: any;
  // Runner: any = {};
  DisplayMessage: any = '';
  tempBetPL: 0;
  GameType: any = '';
  MarketHistoryList: any = [];
  MarketHistoryDetails: any = {
    DisplayID: '', Winner: '', TableCard: [''], PlayerCard: ['', '', ''], DealerCard: ['', '', ''], PlayerScore: 0, DealerScore: 0, PlayerACard: ['', '', ''], PlayerBCard: ['', '', ''], PlayerCCard: ['', '', ''], PlayerTCard: [''], Player1Card: ['', ''], Player2Card: ['', ''], Player3Card: ['', ''], Player4Card: ['', ''], Player5Card: ['', ''], Player6Card: ['', ''], SpadeCard: ['', '', '', '', '', ''], ClubCard: ['', '', '', '', '', ''], DiamondCard: ['', '', '', '', '', ''], HeartCard: ['', '', '', '', '', ''], PlayerAScore: 0, PlayerBScore: 0, BetList: [], Card: {}, winHand: { Dragon: '', DragonSuite: '', TigerSuite: '', Tiger: '' }, SilverCard: [''], GoldCard: [''], PlayerDCard: ['', '', ''], PlayerECard: ['', '', ''], PlayerCScore: 0, PlayerDScore: 0, PlayerEScore: 0,
    Player0: { Score: 0, Status: 0, Cards: ['', '', ''] },
    Player1: { Score: 0, Status: 0, Cards: ['', '', ''] },
    Player2: { Score: 0, Status: 0, Cards: ['', '', ''] },
    Player3: { Score: 0, Status: 0, Cards: ['', '', ''] },
    WinningHand: '',
    TeamA: { Run: [""], Score: "0", Wicket: "0", Over: "0.0", Cards: [] },
    TeamB: { Run: [""], Score: "0", Wicket: "0", Over: "0.0", Cards: [] },
    CKT20: {
      Card: '',
      TeamA: { Run: "0", Wicket: "0", Over: "0" },
      TeamB: { Run: "0", Wicket: "0", Over: "0" }
    }
  };
  abWinnerHand = { Hand: '', JokerSuite: '', WinnerSuite: '' };
  ARWWinningHand = { Hand: '', Suite: '', Seven: '' };
  JKRWinnerHand = { Number: '', Color: '', CardSuit: '' };
  CardRaceWinninghand = { Hand: '', Color: '' };
  rockPaperScissors: any = { Winner: { Silver: '', Gold: '' }, WinningHand: '' };

  // For custome pagination start
  pageIndex: any = 0;
  perPageData: any = 50;
  pager: any = {};
  iniflag: any = 1;
  rowCount = 0;
  pagedItems: any[];
  SearchText: any = '';
  shortBy = 0;
  selectedGameCode = '';
  currentPage = 1;
  slideConfig = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    draggable: true,
    waitForAnimate: false,
    initialSlide: 0,
    responsive: [
      { breakpoint: 600, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    ],
    method: {}
  };
  WheelWinninHand = { Color: "", Hand: "", ThreeRunner: "", SixRunner: "", TwelveRunner: "", EighteenRunner: "", RowRunner: "" };
  SOWinningHand = { TeamA: [], TeamB: [], Common_Boundry: false, Common_Wicket: false, };
  PopupLoader = false;
  GameListInterval: any;
  constructor(
    private router: Router,
    public constant: ConstantService,
    private pagerService: PagerService,
    private marketService: MarketService,
    private toastr: ToastrService,
    private casinoService: CasinoService,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.constant.newsList = [];
    // const url = new URL(window.location.href);
    // const Token = url.searchParams.get('Token');
    this.PopupLoader = false;
    this.Token = sessionStorage.getItem('AuthToken');
    if (this.Token !== '') {
      // this.Token = Token;
      // sessionStorage.setItem('AuthToken', this.Token);
      let today: any = new Date();
      let dd = String(today.getDate()).padStart(2, '0');
      let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      let yyyy = today.getFullYear();

      today = yyyy + '-' + mm + '-' + dd;
      // const today = new Date(new Date().toJSON().replace(/[zZ]/, '')).toJSON().substring(0, 10);
      this.StartDate = today;
      this.EndDate = today;
      this.MaxDate = today;
      // const gameId = sessionStorage.getItem('SelectedGame');
      // this.SelectedGame = (gameId) ? gameId : 0;
      // sessionStorage.removeItem('SelectedGame');
      this.SelectedGame = 0;
      this.SelectedGameCode = '';
      this.GameList = [];
      this.TempGameList = [];
      clearInterval(this.GameListInterval);
      this.GameListInterval = setInterval(() => {
        if (this.GameList.length <= 0) {
          this.GameList = sessionStorage.getItem('GameList') ? JSON.parse(sessionStorage.getItem('GameList')) : [];
          this.TempGameList = this.GameList.filter((e) => e.GameType === this.SelectedGameType + "Game");
        } else {
          clearInterval(this.GameListInterval);
        }
      }, 500);
      this.constant.userName = sessionStorage.getItem('UserName');
      this.constant.IsVerified = true;
      this.GetBalance();
    } else {
      this.constant.IsVerified = false;
      // this.DisplayMessage = 'Invalid Token. Please Login Again.';
    }
    $('.casinocard').on('load', function () {
      setTimeout(() => {
        $(this.parentElement.parentElement).addClass('flip');
      }, 10);
    });
  }


  SearchMarketHistory() {
    // if (this.SelectedGame === 0 || this.SelectedGame === '0') {
    //   this.toastr.error('Please select game');
    //   return;
    // }
    if (this.StartDate === '') {
      this.toastr.error(this.translateService.instant('Please select from date'));
      return;
    }
    if (this.EndDate === '') {
      this.toastr.error(this.translateService.instant('Please select to date'));
      return;
    }
    const maxTime = new Date(this.MaxDate).getTime();
    const startTime = new Date(this.StartDate).getTime();
    const endTime = new Date(this.EndDate).getTime();
    if (startTime > maxTime) {
      this.toastr.error(this.translateService.instant('Please select valid from date'));
      return;
    } else if (endTime > maxTime) {
      this.toastr.error(this.translateService.instant('Please select valid to date'));
      return;
    } else if (startTime > endTime) {
      this.toastr.error(this.translateService.instant('Please select valid from and to date'));
      return;
    }
    this.GetMarketHistory(1);
  }

  async GetMarketHistory(item: any) {
    if (item === 1) {
      // this.pageIndex = 0;
      this.iniflag = 1;
    }
    let game: any = {};
    // let gameType = '';
    this.GameList.map(ele => {
      if (this.SelectedGame == ele.GameCode) {
        game = ele;
      }
    });
    // if (this.SelectedGame != '0') {
    //   // this.SelectedGame = 0;
    //   // this.SelectedGame = game.GameID;
    //   if (game.GameType == "LiveGame") {
    //     gameType = 'Live';
    //   } else if (game.GameType == "VirtualGame") {
    //     gameType = 'Virtual';
    //   }
    // }

    this.IsCallMade = true;
    await this.marketService.getMarketHistory({
      GameCode: game.GameCode,
      GameId: game.GameID,
      StartDate: new Date(this.StartDate + 'T00:00').toUTCString(),
      EndDate: new Date(new Date(this.EndDate + 'T23:59:59').getTime() + 999).toUTCString(),
      PageIndex: this.pageIndex,
      PageSize: this.perPageData,
      GameType: this.SelectedGameType,
      // GameType: gameType,
    }).subscribe(data => {
      this.constant.IsVerified = true;
      if (data.Status.code === 0) {
        if (data.MarketHistory) {
          this.MarketHistoryList = data.MarketHistory;
          this.rowCount = data.RowCount;
        }
        if (this.iniflag === 1) {
          // this.setPage(1);
          this.iniflag = 0;
        }
      } else {
        this.toastr.error(this.constant.TranslateErrorCode(data.Status));
      }
    }, err => {
      // this.onError(err);
    });
  }

  setPage(event) {
    this.currentPage = event;
    this.pageIndex = event - 1;
    this.GetMarketHistory(1);
  }
  async GetMarketHistoryDetails(item) {
    this.PopupLoader = true;
    this.selectedGameCode = item.GameCode;
    // this.Runner = this.constant.GameRunner[item.GameCode];
    $('.mhistorycard').removeClass('flip');
    this.MarketHistoryDetails = {
      DisplayID: '', Winner: '', TableCard: [''], PlayerACard: ['', '', ''], PlayerBCard: ['', '', ''], PlayerCCard: ['', '', ''], PlayerTCard: [''], Player1Card: ['', ''], Player2Card: ['', ''], Player3Card: ['', ''], Player4Card: ['', ''], Player5Card: ['', ''], Player6Card: ['', ''], SpadeCard: ['', '', '', '', '', ''], ClubCard: ['', '', '', '', '', ''], DiamondCard: ['', '', '', '', '', ''], HeartCard: ['', '', '', '', '', ''], PlayerAScore: 0, PlayerBScore: 0, BetList: [], Card: {}, winHand: { Dragon: '', DragonSuite: '', TigerSuite: '', Tiger: '' }, SilverCard: [''], GoldCard: [''], PlayerCard: ['', '', ''], DealerCard: ['', '', ''], PlayerScore: 0, DealerScore: 0, PlayerDCard: ['', '', ''], PlayerECard: ['', '', ''], PlayerCScore: 0, PlayerDScore: 0, PlayerEScore: 0,
      Player0: { Score: 0, Status: 0, Cards: ['', '', ''] },
      Player1: { Score: 0, Status: 0, Cards: ['', '', ''] },
      Player2: { Score: 0, Status: 0, Cards: ['', '', ''] },
      Player3: { Score: 0, Status: 0, Cards: ['', '', ''] },
      WinningHand: '',
      TeamA: { Run: [""], Score: "0", Wicket: "0", Over: "0.0", Cards: [] },
      TeamB: { Run: [""], Score: "0", Wicket: "0", Over: "0.0", Cards: [] },
      CKT20: {
        Card: '',
        TeamA: { Run: "0", Wicket: "0", Over: "0" },
        TeamB: { Run: "0", Wicket: "0", Over: "0" }
      }
    };
    this.IsCallMade = true;
    let UserId = 0;
    if (item.GameType === 'Live') {
      UserId = this.constant.liveUserDetail.ClientUserId;
    } else {
      UserId = this.constant.virtualUserDetail.ClientUserId;
    }
    await this.marketService.getMarketHistoryDetails({ RoundSummaryID: item.RoundSummaryID, GameType: item.GameType, ClientUserID: UserId }).subscribe(data => {
      this.IsCallMade = false;
      this.PopupLoader = false;
      if (data.Status.code === 0) {
        if (data.RoundData && data.BetList) {
          this.MarketHistoryDetails.BetList = data.BetList;
          this.MarketHistoryDetails.DisplayID = item.Description;
          this.MarketHistoryDetails.Winner = data.RoundData.Winner.trim();
          this.MarketHistoryDetails.WinningHand = data.RoundData.WinningHand ? data.RoundData.WinningHand.trim() : '';
          this.WheelWinninHand = { Color: "", Hand: "", ThreeRunner: "", SixRunner: "", TwelveRunner: "", EighteenRunner: "", RowRunner: "" };
          this.SOWinningHand = { TeamA: [], TeamB: [], Common_Boundry: false, Common_Wicket: false, };
          data.RoundData.GameCode = data.RoundData.GameCode ? data.RoundData.GameCode.trim() : '';
          const cards = JSON.parse(data.RoundData.Cards);
          if (data.RoundData.GameCode === 'TP' || data.RoundData.GameCode === 'VTP' || data.RoundData.GameCode === 'TP20' || data.RoundData.GameCode === 'VTP20' || data.RoundData.GameCode === 'TPFO' || data.RoundData.GameCode === 'TP7M' || data.RoundData.GameCode === 'MTP7M') {
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA.trim().split(' ');
            this.MarketHistoryDetails.PlayerBCard = cards.PlayerB.trim().split(' ');
            // } else if (data.RoundData.GameCode === 'TPFO') {
            //   this.MarketHistoryDetails.PlayerCard = cards.Player.trim().split(' ');
            //   this.MarketHistoryDetails.DealerCard = cards.Dealer.trim().split(' ');
          } else if (data.RoundData.GameCode === 'BAC' || data.RoundData.GameCode === 'VBAC' || data.RoundData.GameCode === 'VBAC20') {
            this.MarketHistoryDetails.PlayerACard = cards.Player.trim().split(' ');
            this.MarketHistoryDetails.PlayerBCard = cards.Banker.trim().split(' ');
            this.MarketHistoryDetails.PlayerAScore = (cards.PlayerScore) ? Number(cards.PlayerScore) : 0;
            this.MarketHistoryDetails.PlayerBScore = (cards.BankerScore) ? Number(cards.BankerScore) : 0;
          } else if (data.RoundData.GameCode === 'DT' || data.RoundData.GameCode === 'VDT' || data.RoundData.GameCode === 'VDT20' || data.RoundData.GameCode === 'DT20') {
            this.MarketHistoryDetails.PlayerACard = cards.Dragon.trim().split(' ');
            this.MarketHistoryDetails.PlayerBCard = cards.Tiger.trim().split(' ');
            const winHand = JSON.parse(data.RoundData.WinningHand);
            this.MarketHistoryDetails.winHand = { Dragon: winHand.Dragon, DragonSuite: winHand.DragonSuite, TigerSuite: winHand.TigerSuite, Tiger: winHand.Tiger };
          } else if (data.RoundData.GameCode === 'DT7M') {
            this.MarketHistoryDetails.PlayerACard = cards.Dragon.Cards.trim().split(' ');
            this.MarketHistoryDetails.PlayerBCard = cards.Tiger.Cards.trim().split(' ');
            const winHand = JSON.parse(data.RoundData.WinningHand);
            this.MarketHistoryDetails.winHand = { Dragon: winHand.Dragon, DragonSuite: winHand.DragonSuite, TigerSuite: winHand.TigerSuite, Tiger: winHand.Tiger };
          } else if (data.RoundData.GameCode === 'PK' || data.RoundData.GameCode === 'VPK' || data.RoundData.GameCode === 'VPK20' || data.RoundData.GameCode === 'PK20') {
            this.MarketHistoryDetails.TableCard = cards.Table.trim().split(' ');
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA.trim().split(' ');
            this.MarketHistoryDetails.PlayerBCard = cards.PlayerB.trim().split(' ');
          } else if (data.RoundData.GameCode === 'AB' || data.RoundData.GameCode === 'VAB20' || data.RoundData.GameCode === 'AB20') {
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA.trim().split(' ');
            this.MarketHistoryDetails.PlayerBCard = cards.PlayerB.trim().split(' ');
            this.MarketHistoryDetails.PlayerTCard = cards.PlayerT.trim().split(' ');
            this.abWinnerHand = { Hand: '', JokerSuite: '', WinnerSuite: '' };
            if (data.RoundData.WinningHand) {
              const winHand = JSON.parse(data.RoundData.WinningHand);
              this.abWinnerHand = { Hand: winHand.Hand, JokerSuite: winHand.JokerSuite, WinnerSuite: winHand.WinnerSuite };
            }
          } else if (data.RoundData.GameCode === 'AB2' || data.RoundData.GameCode === 'ABC') {
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA.trim().split(' ');
            this.MarketHistoryDetails.PlayerBCard = cards.PlayerB.trim().split(' ');
            this.MarketHistoryDetails.PlayerTCard = cards.PlayerT.trim().split(' ');
            this.abWinnerHand = { Hand: '', JokerSuite: '', WinnerSuite: '' };
            if (data.RoundData.WinningHand) {
              const winHand = JSON.parse(data.RoundData.WinningHand);
              this.abWinnerHand = { Hand: "", JokerSuite: "", WinnerSuite: winHand.WinnerSuite };
            }
          } else if (data.RoundData.GameCode === 'WM' || data.RoundData.GameCode === 'VWM') {
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA.trim().split(' ');
          } else if (data.RoundData.GameCode === 'ARW' || data.RoundData.GameCode === 'VARW') {
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA.trim().split(' ');
            this.ARWWinningHand = { Hand: '', Suite: '', Seven: '' };
            if (data.RoundData.WinningHand) {
              const winHand = JSON.parse(data.RoundData.WinningHand);
              this.ARWWinningHand = { Hand: winHand.Hand, Suite: winHand.Suite, Seven: winHand.Seven };
            }
          } else if (data.RoundData.GameCode === 'VJKR' || data.RoundData.GameCode === 'JKR') {
            this.MarketHistoryDetails.PlayerACard = cards.Card.trim().split(' ');
            this.JKRWinnerHand = { Number: '', Color: '', CardSuit: '' };
            if (data.RoundData.WinningHand) {
              const winHand = JSON.parse(data.RoundData.WinningHand);
              this.JKRWinnerHand = { Number: winHand.Number, Color: winHand.Color, CardSuit: winHand.CardSuit };
            }
          } else if (data.RoundData.GameCode === 'VKF' || data.RoundData.GameCode === 'KF') {
            this.MarketHistoryDetails.PlayerACard = cards.Card.trim().split(' ');
          } else if (data.RoundData.GameCode === 'C32' || data.RoundData.GameCode === 'VC32') {
            cards.Player8.Cards = cards.Player8.Cards.trim().split(' ');
            cards.Player9.Cards = cards.Player9.Cards.trim().split(' ');
            cards.Player10.Cards = cards.Player10.Cards.trim().split(' ');
            cards.Player11.Cards = cards.Player11.Cards.trim().split(' ');
            Object.assign(this.MarketHistoryDetails.Card, cards);
          } else if (data.RoundData.GameCode === 'UD7' || data.RoundData.GameCode === 'VUD7') {
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA ? cards.PlayerA.trim().split(' ') : '';
          } else if (data.RoundData.GameCode === 'PK6' || data.RoundData.GameCode === 'VPK6' || data.RoundData.GameCode === 'VPK620' || data.RoundData.GameCode === 'PK620') {
            this.MarketHistoryDetails.TableCard = cards.Table.trim().split(' ');
            this.MarketHistoryDetails.Player1Card = cards.Player1.trim().split(' ');
            this.MarketHistoryDetails.Player2Card = cards.Player2.trim().split(' ');
            this.MarketHistoryDetails.Player3Card = cards.Player3.trim().split(' ');
            this.MarketHistoryDetails.Player4Card = cards.Player4.trim().split(' ');
            this.MarketHistoryDetails.Player5Card = cards.Player5.trim().split(' ');
            this.MarketHistoryDetails.Player6Card = cards.Player6.trim().split(' ');
          } else if (data.RoundData.GameCode === 'V3CJ' || data.RoundData.GameCode === 'D3CJ') {
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA.trim().split(' ');
          } else if (data.RoundData.GameCode === 'V3TP' || data.RoundData.GameCode === 'D3TP') {
            this.MarketHistoryDetails.PlayerACard = cards.PlayerA.trim().split(' ');
            this.MarketHistoryDetails.PlayerBCard = cards.PlayerB.trim().split(' ');
            this.MarketHistoryDetails.PlayerCCard = cards.PlayerC.trim().split(' ');
          } else if (data.RoundData.GameCode === 'VBJ' || data.RoundData.GameCode === 'BJ') {
            Object.assign(this.MarketHistoryDetails.PlayerACard, cards.PlayerA ? cards.PlayerA.Cards.trim().split(' ') : '');
            Object.assign(this.MarketHistoryDetails.PlayerBCard, cards.PlayerB ? cards.PlayerB.Cards.trim().split(' ') : '');
            Object.assign(this.MarketHistoryDetails.PlayerCCard, cards.PlayerC ? cards.PlayerC.Cards.trim().split(' ') : '');
            Object.assign(this.MarketHistoryDetails.PlayerDCard, cards.PlayerD ? cards.PlayerD.Cards.trim().split(' ') : '');
            Object.assign(this.MarketHistoryDetails.PlayerECard, cards.Dealer ? cards.Dealer.Cards.trim().split(' ') : '');
            this.MarketHistoryDetails.PlayerAScore = (cards.PlayerA.Score) ? Number(cards.PlayerA.Score) : 0;
            this.MarketHistoryDetails.PlayerBScore = (cards.PlayerB.Score) ? Number(cards.PlayerB.Score) : 0;
            this.MarketHistoryDetails.PlayerCScore = (cards.PlayerC.Score) ? Number(cards.PlayerC.Score) : 0;
            this.MarketHistoryDetails.PlayerDScore = (cards.PlayerD.Score) ? Number(cards.PlayerD.Score) : 0;
            this.MarketHistoryDetails.PlayerEScore = (cards.Dealer.Score) ? Number(cards.Dealer.Score) : 0;


          } else if (data.RoundData.GameCode === 'VCR' || data.RoundData.GameCode === 'CR') {
            this.MarketHistoryDetails.SpadeCard = cards.Spade.trim().split(' ');
            this.MarketHistoryDetails.ClubCard = cards.Club.trim().split(' ');
            this.MarketHistoryDetails.DiamondCard = cards.Diamond.trim().split(' ');
            this.MarketHistoryDetails.HeartCard = cards.Heart.trim().split(' ');
            this.CardRaceWinninghand = { Hand: '', Color: '' };
            if (data.RoundData.WinningHand) {
              const winHand = JSON.parse(data.RoundData.WinningHand);
              this.CardRaceWinninghand = { Hand: winHand.Hand, Color: winHand.Color };
            }
          } else if (data.RoundData.GameCode === 'VBJC' || data.RoundData.GameCode === 'BJC' || data.RoundData.GameCode === 'IBJ') {
            this.MarketHistoryDetails.PlayerCard = cards.Player.Cards.trim().split(' ');
            this.MarketHistoryDetails.DealerCard = cards.Dealer.Cards.trim().split(' ');
            this.MarketHistoryDetails.PlayerScore = (cards.Player.Score) ? Number(cards.Player.Score) : 0;
            this.MarketHistoryDetails.DealerScore = (cards.Dealer.Score) ? Number(cards.Dealer.Score) : 0;
          } else if (data.RoundData.GameCode === 'VRPS' || data.RoundData.GameCode === 'RPS') {
            // this.rockPaperScissors = { DisplayID: '', Winner: { Silver: '', Gold: '' }, SilverCard: [''], GoldCard: [''], WinningHand: '' };
            this.MarketHistoryDetails.SilverCard = cards.Silver ? cards.Silver.trim().split(' ') : '';
            this.MarketHistoryDetails.GoldCard = cards.Gold ? cards.Gold.trim().split(' ') : '';
            if (data.RoundData.Winner) {
              const winHand = JSON.parse(data.RoundData.Winner);
              this.rockPaperScissors.Winner.Silver = winHand.Silver;
              this.rockPaperScissors.Winner.Gold = winHand.Gold;
            }
          } else if (data.RoundData.GameCode === 'CQ' || data.RoundData.GameCode === 'RCQ' || data.RoundData.GameCode === 'CQ20' || data.RoundData.GameCode === 'RCQ20') {

            Object.assign(this.MarketHistoryDetails.Player0.Cards, cards.Player0 ? cards.Player0.Cards.trim().split(' ') : '');
            Object.assign(this.MarketHistoryDetails.Player1.Cards, cards.Player1 ? cards.Player1.Cards.trim().split(' ') : '');
            Object.assign(this.MarketHistoryDetails.Player2.Cards, cards.Player2 ? cards.Player2.Cards.trim().split(' ') : '');
            Object.assign(this.MarketHistoryDetails.Player3.Cards, cards.Player3 ? cards.Player3.Cards.trim().split(' ') : '');
            this.MarketHistoryDetails.Player0.Score = (cards.Player0.Score) ? Number(cards.Player0.Score) : 0;
            this.MarketHistoryDetails.Player1.Score = (cards.Player1.Score) ? Number(cards.Player1.Score) : 0;
            this.MarketHistoryDetails.Player2.Score = (cards.Player2.Score) ? Number(cards.Player2.Score) : 0;
            this.MarketHistoryDetails.Player3.Score = (cards.Player3.Score) ? Number(cards.Player3.Score) : 0;
            this.MarketHistoryDetails.WinningHand = data.RoundData.WinningHand;

            setTimeout(() => {
              if (this.MarketHistoryDetails.Player0.Cards.length > 3) {
                this.ModelSlidePlayerCard("Player0");
              }
              if (this.MarketHistoryDetails.Player1.Cards.length > 3) {
                this.ModelSlidePlayerCard("Player1");
              }
              if (this.MarketHistoryDetails.Player2.Cards.length > 3) {
                this.ModelSlidePlayerCard("Player2");
              }
              if (this.MarketHistoryDetails.Player3.Cards.length > 3) {
                this.ModelSlidePlayerCard("Player3");
              }
            }, 100);

          } else if (data.RoundData.GameCode === 'WH' || data.RoundData.GameCode === 'RT') {
            if (data.RoundData.WinningHand) {
              const winHand = JSON.parse(data.RoundData.WinningHand);
              this.WheelWinninHand = { Color: winHand.Color, Hand: winHand.Hand, ThreeRunner: winHand.ThreeRunner, SixRunner: winHand.SixRunner, TwelveRunner: winHand.TwelveRunner, EighteenRunner: winHand.EighteenRunner, RowRunner: winHand.RowRunner };
            }
          } else if (data.RoundData.GameCode === 'SO' || data.RoundData.GameCode === 'RSO') {
            this.MarketHistoryDetails.TeamA.Run = cards.TeamA.Run.trim().split(' ');
            this.MarketHistoryDetails.TeamB.Run = cards.TeamB.Run.trim().split(' ');
            this.MarketHistoryDetails.TeamA.Score = cards.TeamA.Score;
            this.MarketHistoryDetails.TeamB.Score = cards.TeamB.Score;
            this.MarketHistoryDetails.TeamA.Wicket = cards.TeamA.Wicket;
            this.MarketHistoryDetails.TeamB.Wicket = cards.TeamB.Wicket;
            this.MarketHistoryDetails.TeamA.Over = cards.TeamA.Over;
            this.MarketHistoryDetails.TeamB.Over = cards.TeamB.Over;
            this.MarketHistoryDetails.TeamA.Cards = cards.TeamA.Cards.trim().split(' ');
            this.MarketHistoryDetails.TeamB.Cards = cards.TeamB.Cards.trim().split(' ');
            if (data.RoundData.WinningHand) {
              const winHand = JSON.parse(data.RoundData.WinningHand);
              this.SOWinningHand = { TeamA: winHand.TeamA, TeamB: winHand.TeamB, Common_Boundry: winHand.Common_Boundry, Common_Wicket: winHand.Common_Wicket };
            }
          } else if (data.RoundData.GameCode === 'CKT20' || data.RoundData.GameCode === 'RCKT20') {
            Object.assign(this.MarketHistoryDetails.CKT20.TeamA, cards.TeamA);
            Object.assign(this.MarketHistoryDetails.CKT20.TeamB, cards.TeamB);
            this.MarketHistoryDetails.CKT20.Card = cards.Card;
            // this.MarketHistoryDetails.Winner = item.Winner ? item.Winner.trim() : '';
            // this.MarketHistoryDetails.WinningHand = item.WinningHand ? item.WinningHand.trim() : '';

          }

          let NetPl = 0;
          this.MarketHistoryDetails.BetList.forEach(element => {
            if (element.IsBetWon) {
              element.Net = element.BetPL + NetPl;
            }
            else {
              element.Net = -element.BetPL + NetPl;
            }
            NetPl = element.Net;
          });
        }
      } else {
        this.toastr.error(this.constant.TranslateErrorCode(data.Status));
      }
    }, err => {
      // console.log(err)
      // this.onError(err);
    });
  }

  private onError(err) {
    this.IsCallMade = false;
    this.toastr.error(this.translateService.instant('Somethingwent'));
    // if (this.constant.isLobbyShowLive === true || this.constant.isLobbyShowVirtual === true) {
    //   this.router.navigateByUrl('/lobby?Token=' + this.Token);
    // }
  }

  cardNumberToString(item) {
    let number = String(item);
    number = number.substring(1);
    let splitArray = [];
    if (number) {
      splitArray = number.toString().match(/.{1,2}/g);
      if (splitArray.length === 3) {

        for (let i = 0; i < splitArray.length; i++) {
          // var a = splitArray[i];
          if (splitArray[i] === '01') {
            splitArray[i] = splitArray[i].replace(/01/g, 'A');
          } else if (splitArray[i] === '11') {
            splitArray[i] = splitArray[i].replace(/11/g, 'J');
          } else if (splitArray[i] === '12') {
            splitArray[i] = splitArray[i].replace(/12/g, 'Q');
          } else if (splitArray[i] === '13') {
            splitArray[i] = splitArray[i].replace(/13/g, 'K');
          } else if (splitArray[i] !== '10') {
            splitArray[i] = splitArray[i].replace(/0/g, '');
          }
        }
        return '( ' + splitArray[0] + ' ' + splitArray[1] + ' ' + splitArray[2] + ' )';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  JokerNumber(num) {
    if (num === '14') { return 'JOKER'; }
    else if (num === '1') { return 'A'; }
    else if (num === '11') { return 'J'; }
    else if (num === '12') { return 'Q'; }
    else if (num === '13') { return 'K'; }
    else if (num === '0') { return '-'; }
    else { return num; }
  }
  private async GetBalance() {
    if (!this.IsCallMade) {
      this.IsCallMade = true;
      const userDetail = new BalaBalanceModel();
      await this.casinoService.GetBalance(userDetail).subscribe(data => {
        this.IsCallMade = false;
        if (data.Status.code === this.constant.HttpResponceCode.Success) {
          this.constant.IsVerified = true;
          this.constant.getIsVerified.next(this.constant.IsVerified);
          if (data.Balance !== undefined && data.Balance != null) {
            this.constant.balance = Number(data.Balance);
            this.constant.liability = Number(data.Liability);

          } else {
            this.constant.IsVerified = false;
            this.toastr.error(this.translateService.instant('EC0053'));
            // this.router.navigateByUrl('/lobby?Token=' + this.Token);
            return;
          }
        } else if (data.Status.code === this.constant.HttpResponceCode.Invalid) {
          this.constant.IsVerified = false;
          this.DisplayMessage = this.translateService.instant(this.constant.ErrorMsg.Invalid);
        } else {
          this.constant.IsVerified = false;
          this.DisplayMessage = this.constant.TranslateErrorCode(data.Status)
          this.toastr.error(this.constant.TranslateErrorCode(data.Status));
          // clearInterval(this.balanceInterval);
        }
      }, err => {
        // this.onError(err);
      });
    }
  }
  getNetPl(item) {
    this.tempBetPL = item;
    return;
  }
  RunnerName(runner) {
    if (this.selectedGameCode == "DT" || this.selectedGameCode == "DT20" || this.selectedGameCode == "VDT" || this.selectedGameCode == "DT20" || this.selectedGameCode == "DT7M") {
      if (runner == 'PlayerA') {
        return 'Dragon';
      }
      else if (runner == 'PlayerB') {
        return 'Tiger';
      }
      else if (runner == 'PlayerT') {
        return 'Tie';
      }
      else if (runner == 'DragonOdd') {
        return 'Dragon Odd';
      }
      else if (runner == 'DragonEven') {
        return 'Dragon Even';
      }
      else if (runner == 'DragonSuiteRed') {
        return 'Dragon Suite Red';
      }
      else if (runner == 'DragonSuiteBlack') {
        return 'Dragon Suite Black';
      }
      else if (runner == 'TigerOdd') {
        return 'Tiger Odd';
      }
      else if (runner == 'TigerEven') {
        return 'Tiger Even';
      }
      else if (runner == 'TigerSuiteRed') {
        return 'Tiger Suite Red';
      }
      else if (runner == 'TigerSuiteBlack') {
        return 'Tiger Suite Black';
      }
    }
    if (this.selectedGameCode == "AB") {
      if (runner == 'PlayerA') {
        return 'Andar';
      }
      if (runner == 'PlayerB') {
        return 'Bahar';
      }
    }
    if (this.selectedGameCode == "WH" || this.selectedGameCode == "RT") {
      if (runner == 'Number') { return "Number " }
      else if (runner == 'Player1TO3') { return "1 to 3" }
      else if (runner == 'Player4TO6') { return "4 to 6" }
      else if (runner == 'Player7TO9') { return "7 to 9" }
      else if (runner == 'Player10TO12') { return "10 to 12" }
      else if (runner == 'Player13TO15') { return "13 to 15" }
      else if (runner == 'Player16TO18') { return "16 to 18" }
      else if (runner == 'Player19TO21') { return "19 to 21" }
      else if (runner == 'Player22TO24') { return "22 to 24" }
      else if (runner == 'Player25TO27') { return "25 to 27" }
      else if (runner == 'Player28TO30') { return "28 to 30" }
      else if (runner == 'Player31TO33') { return "31 to 33" }
      else if (runner == 'Player34TO36') { return "34 to 36" }
      else if (runner == 'Player1TO6') { return "1 to 6" }
      else if (runner == 'Player7TO12') { return "7 to 12" }
      else if (runner == 'Player13TO18') { return "13 to 18" }
      else if (runner == 'Player19TO24') { return "19 to 24" }
      else if (runner == 'Player25TO30') { return "25 to 30" }
      else if (runner == 'Player31TO36') { return "31 to 36" }
      else if (runner == 'Player1TO12') { return "1 to 12" }
      else if (runner == 'Player13TO24') { return "13 to 24" }
      else if (runner == 'Player25TO36') { return "25 to 36" }
      else if (runner == 'Player1TO18') { return "1 to 18" }
      else if (runner == 'Player19TO36') { return "19 to 36" }
      else if (runner == 'PlayerI2TO1') { return "Row I 2:1" }
      else if (runner == 'PlayerII2TO1') { return "Row II 2:1" }
      else if (runner == 'PlayerIII2TO1') { return "Row III 2:1" }
      else if (runner == 'Even') { return "Even" }
      else if (runner == 'Odd') { return "Odd" }
      else if (runner == 'Black') { return "Black" }
      else if (runner == 'Red') { return "Red" }
      else if (runner == 'SectorGreaterThan_185') { return "Sector Greater Than (18.5)" }
      else if (runner == 'SectorGreaterThan_145') { return "Sector Greater Than (14.5)" }
      else if (runner == 'SectorGreaterThan_225') { return "Sector Greater Than (22.5)" }
      else if (runner == 'SectorGreaterThan_95') { return "Sector Greater Than (9.5)" }
      else if (runner == 'SectorGreaterThan_275') { return "Sector Greater Than (27.5)" }
      else if (runner == 'Split') { return "Split" }
      else if (runner == 'Square') { return "Square" }
    } else {
      return runner;
    }
  }
  ModelSlidePlayerCard(player) {
    if (player == "Player0") {
      const slideNo = Number(this.MarketHistoryDetails.Player0.Cards.length - 3);
      $('.carouselm-a').slick('slickGoTo', slideNo);
    } else if (player == "Player1") {
      const slideNo = Number(this.MarketHistoryDetails.Player1.Cards.length - 3);
      $('.carouselm-b').slick('slickGoTo', slideNo);
    } else if (player == "Player2") {
      const slideNo = Number(this.MarketHistoryDetails.Player2.Cards.length - 3);
      $('.carouselm-c').slick('slickGoTo', slideNo);
    } else if (player == "Player3") {
      const slideNo = Number(this.MarketHistoryDetails.Player3.Cards.length - 3);
      $('.carouselm-d').slick('slickGoTo', slideNo);
    }
  }
  trackByFn(index, item) {
    return index; // or item.id
  }
  WheelRTNumber(runner, number) {
    if (number !== null && (runner == "Number" || runner == "Split" || runner == "Square")) {
      // .slice(1)
      let num = String(number);
      if (runner == "Number") {
        if (number == "100") {
          return num.slice(1);
        } else {
          return num;
        }
      } else {
        num = num.slice(1);
        return num.match(/.{1,2}/g);
      }
    } else {
      return null;
    }
  }
  SelectedType(type) {
    console.log(type);
  }
  TitleName(item) {
    if (item.DisplayID !== undefined && item.DisplayID !== '') {
      return item.DisplayID.replace('Virtual', 'RNG');
    } else {
      return null;
    }
  }
  GameDescription(item) {
    if (item.Description !== undefined && item.Description !== '') {
      return item.Description.replace('Virtual', 'RNG');
    } else {
      return null;
    }
  }
  ChangeEvent(e) {
    // console.log(e,this.SelectedGameType);
    this.TempGameList = this.GameList.filter((e) => e.GameType === this.SelectedGameType + "Game");
  }
}
